export default __webpack_public_path__ + "cbade9acf233b828c7dc8dd7af77def4.png";